module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.cartitem.sourceType == '1' || _vm.cartitem.sourceType == null || _vm.cartitem.sourceType == 0) ? _c('mu-list-item', {
    key: _vm.cartitem.id,
    staticClass: "list-box",
    class: [_vm.isRightTriggle ? 'hasright' : ''],
    attrs: {
      "title": _vm.cartitem.goodsName
    },
    on: {
      "click": function($event) {
        return _vm.clickItem(_vm.cartitem.goodsId, _vm.cartitem.skuId || 0)
      }
    }
  }, [_c('mu-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isCheckBox),
      expression: "isCheckBox"
    }],
    staticClass: "list-radio",
    attrs: {
      "name": "group",
      "nativeValue": _vm.cartitem.favId
    },
    model: {
      value: (_vm.value),
      callback: function($$v) {
        _vm.value = $$v
      },
      expression: "value"
    }
  }), _vm._v(" "), _c('imgs', {
    attrs: {
      "slot": "leftAvatar",
      "width": _vm.width,
      "height": _vm.height,
      "imagePath": _vm.cartitem.imagePath && _vm.cartitem.imagePath.imagePath
    },
    slot: "leftAvatar"
  }), _vm._v(" "), _c('div', {
    staticClass: "listItem"
  }, [_c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.cartitem.salePrice || _vm.cartitem.orderGoodsPrice || _vm.cartitem.goodsPrice) + "\n        "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartitem.goodsNum),
      expression: "cartitem.goodsNum"
    }],
    staticClass: "count"
  }, [_vm._v("x" + _vm._s(_vm.cartitem.goodsNum))])])]), _vm._v(" "), _c('div', {
    staticClass: "clear"
  }), _vm._v(" "), (_vm.isRightTriggle) ? _c('img', {
    staticClass: "user-right",
    attrs: {
      "src": "/static/images/ic_more_3x.png"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.cartitem.sourceType == '2') ? [_c('mu-list-item', {
    key: _vm.cartitem.id,
    staticClass: "list-box diy-title",
    class: [_vm.isRightTriggle ? 'hasright' : ''],
    attrs: {
      "title": _vm.cartitem.goodsName
    }
  }, [_c('div', {
    staticClass: "point"
  }), _vm._v(" "), _c('div', {
    staticClass: "listItem"
  }, [_c('p', {
    staticClass: "price"
  }, [_vm._v("￥" + _vm._s(_vm.cartitem.salePrice || _vm.cartitem.orderGoodsPrice) + "\n          "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cartitem.goodsNum),
      expression: "cartitem.goodsNum"
    }],
    staticClass: "count"
  }, [_vm._v("x" + _vm._s(_vm.cartitem.goodsNum))])])])]), _vm._v(" "), _vm._l(((_vm.cartitem.subCartGoods || _vm.cartitem.subGoodsOrderMsgs)), function(sub, subindex) {
    return [_c('mu-list-item', {
      key: sub.id,
      staticClass: "list-box diy-list",
      class: [_vm.isRightTriggle ? 'hasright' : ''],
      attrs: {
        "title": sub.goodsName
      },
      on: {
        "click": function($event) {
          return _vm.clickItem(sub.goodsId, sub.skuId || 0)
        }
      }
    }, [(_vm.cartitem.subCartGoods) ? _c('div', {
      staticClass: "point",
      class: [subindex == (_vm.cartitem.subCartGoods.length - 1) ? 'last' : '']
    }) : _vm._e(), _vm._v(" "), (_vm.cartitem.subGoodsOrderMsgs) ? _c('div', {
      staticClass: "point",
      class: [subindex == (_vm.cartitem.subGoodsOrderMsgs.length - 1) ? 'last' : '']
    }) : _vm._e(), _vm._v(" "), _c('imgs', {
      attrs: {
        "slot": "leftAvatar",
        "imagePath": sub.imagePath && sub.imagePath.imagePath
      },
      slot: "leftAvatar"
    }), _vm._v(" "), _c('div', {
      staticClass: "listItem"
    }, [_c('p', {
      staticClass: "price"
    }, [_vm._v("￥" + _vm._s(sub.salePrice || sub.orderGoodsPrice) + "\n            "), _c('label', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (sub.goodsNum),
        expression: "sub.goodsNum"
      }],
      staticClass: "count"
    }, [_vm._v("x" + _vm._s(sub.goodsNum))])])]), _vm._v(" "), _c('div', {
      staticClass: "clear"
    }), _vm._v(" "), (_vm.isRightTriggle) ? _c('img', {
      staticClass: "user-right",
      attrs: {
        "src": "/static/images/ic_more_3x.png"
      }
    }) : _vm._e()], 1)]
  })] : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cab4cf64","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/myOrdersItem/myOrdersItem.vue
// module id = 418
// module chunks = 68